exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".hairline-top:before{top:0;bottom:auto;transform-origin:0 0;-webkit-transform-origin:0 0;transform:scaleY(.5);-webkit-transform:scaleY(.5)}.hairline-bottom:after,.hairline-top:before{content:\"\";position:absolute;background-color:#ddd;display:block;left:0;right:auto;height:1px;width:100%}.hairline-bottom:after{top:atuo;bottom:0;transform-origin:0 100%;-webkit-transform-origin:0 100%;transform:scaleY(.5);-webkit-transform:scaleY(.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/sass-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/list/HairlineItem.vue
// module id = 165
// module chunks = 0